/**
 * Generic labeled toggle switch: a knob + label pair over the shared `.toggle-group` /
 * `.hints-toggle*` CSS vocabulary (skat.css). Extracted from game-start/game-start-ui.js
 * (game-menu-hint-learning-toggles design) once a second mount point — game-menu.js's mid-game
 * hints/learning toggles — needed the identical control; moved verbatim, not redesigned.
 */
export function createToggle(label, active, onToggle) {
  const group = document.createElement("div");
  group.className = "toggle-group";
  const toggle = document.createElement("div");
  toggle.className = "hints-toggle" + (active ? " active" : "");
  toggle.innerHTML = '<div class="hints-toggle-knob"></div>';
  toggle.addEventListener("click", () => {
    const nowActive = !toggle.classList.contains("active");
    toggle.classList.toggle("active", nowActive);
    onToggle(nowActive);
  });
  const labelEl = document.createElement("span");
  labelEl.className = "hints-label";
  labelEl.textContent = label;
  group.appendChild(toggle);
  group.appendChild(labelEl);
  return group;
}

/**
 * Re-presses a built group's knob to `active` — the `segmented-picker.js#pressSegmentedPicker`
 * sibling, for a mount that goes stale because another live surface over the same setting changed
 * it (profile-overlay-and-menu-slim design § Settings ownership: the profile overlay writes, the
 * start screen's inline control bank has to follow). Visual-only — never fires `onToggle`: the
 * setting already holds the new value, so re-running the flip's side effects would double them.
 */
export function pressToggle(group, active) {
  group.querySelector(".hints-toggle").classList.toggle("active", active);
}
